import React, { useState, useEffect } from "react";
import Config from "@Config";

const componentClassname = "react-form";

const FormPasswordWithValidation = props => {
    const [passwordHasDigits, setPasswordHasDigits] = useState(false);
    const [
        passwordHasSpecialCharacters,
        setPasswordHasSpecialCharacters,
    ] = useState(false);
    const [passwordHasLowercase, setPasswordHasLowercase] = useState(false);
    const [passwordHasUppercase, setPasswordUppercase] = useState(false);

    useEffect(() => {
        if (props.inputElement.ref.current !== null) {
            if (
                Config.Regex.passwordDigits.test(
                    props.inputElement.ref.current.value
                ) === true
            ) {
                setPasswordHasDigits(true);
            } else {
                setPasswordHasDigits(false);
            }
            if (
                Config.Regex.passwordSpecialCharacters.test(
                    props.inputElement.ref.current.value
                ) === true
            ) {
                setPasswordHasSpecialCharacters(true);
            } else {
                setPasswordHasSpecialCharacters(false);
            }
            if (
                Config.Regex.passwordLowercase.test(
                    props.inputElement.ref.current.value
                ) === true
            ) {
                setPasswordHasLowercase(true);
            } else {
                setPasswordHasLowercase(false);
            }
            if (
                Config.Regex.passwordUppercase.test(
                    props.inputElement.ref.current.value
                ) === true
            ) {
                setPasswordUppercase(true);
            } else {
                setPasswordUppercase(false);
            }
        }
    });

    return (
        <div
            className={`${componentClassname}__field 
                ${componentClassname}__field--${props.type}
                ${props.classes.inheritedClasses} 
                ${props.classes.isDisabled} 
                ${props.classes.isIncomplete} 
                ${props.classes.isFocused} 
                ${props.classes.hasValue}
                ${props.classes.isValid}
                ${props.classes.isInvalid}
                ${props.classes.isChecked}
            `}
        >
            <label htmlFor={props.accessibilityIds.input}>
                {/*label*/}
                {props.label ? (
                    <div className={`${componentClassname}__field__label `}>
                        <div
                            className={`${componentClassname}__field__label__inner`}
                            id={props.accessibilityIds.label}
                        >
                            {props.label}
                        </div>

                        {props.activeLabel ? (
                            <div
                                className={`${componentClassname}__field__label__active`}
                            >
                                {props.activeLabel}
                            </div>
                        ) : null}
                    </div>
                ) : null}
                {/*input element*/}
                {props.inputElement}
                {/*password toggle btn*/}
                {props.passwordToggleBtn}
            </label>

            {/*errors*/}
            {!props.hideErrors &&
            props.errors &&
            props.errors.length &&
            props.showErrors ? (
                <div className={`${componentClassname}__field__errors`}>
                    <div
                        className={`${componentClassname}__field__errors__item`}
                        id={props.accessibilityIds.error}
                    >
                        {props.errors[0]}
                    </div>
                </div>
            ) : null}

            {/* validation box */}
            <div className="react-form__field__password-validation-hint">
                <p className="react-form__field__password-validation-hint__title">
                    Please meet 3 out of the 4 following requirements and the
                    password must have minimum 8 characters:{" "}
                </p>
                <p
                    className={`react-form__field__password-validation-hint__text ${passwordHasDigits &&
                        `react-form__field__password-validation-hint__text--checked`}`}
                >
                    At least 1 digit.
                </p>
                <p
                    className={`react-form__field__password-validation-hint__text ${passwordHasSpecialCharacters &&
                        `react-form__field__password-validation-hint__text--checked`}`}
                >
                    At least 1 special character.
                </p>
                <p
                    className={`react-form__field__password-validation-hint__text ${passwordHasLowercase &&
                        `react-form__field__password-validation-hint__text--checked`}`}
                >
                    At least 1 lowercase.
                </p>
                <p
                    className={`react-form__field__password-validation-hint__text ${passwordHasUppercase &&
                        `react-form__field__password-validation-hint__text--checked`}`}
                >
                    At least 1 uppercase.
                </p>
            </div>

            {/*info*/}
            {props.info ? (
                <div
                    className={`${componentClassname}__field__info`}
                    id={props.accessibilityIds.description}
                >
                    {props.info}
                </div>
            ) : null}
        </div>
    );
};

export default FormPasswordWithValidation;
